import { useContext } from "react";
import { TenantContext } from "./TenantContext";

export default function useTenant() {
  const tenant = useContext(TenantContext)

  if (!tenant) {
    throw new Error("useTenant must be used inside TenantProvider");
  }

  return tenant;
}